import {Component, OnInit} from '@angular/core';
import {CrudConfig} from '@ngx-ivengi/crud';
import {DatagridEmployeeComponent} from '../datagrid/datagrid-employee-component';
import {DatagridService} from '../datagrid/datagrid.service';
import {UIRouter} from '@uirouter/angular';

@Component({
  selector: 'app-archive-employee-overview',
  templateUrl: '../datagrid/datagrid.component.html'
})
export class ArchiveEmployeeOverviewComponent extends DatagridEmployeeComponent implements OnInit {

  public searchEnabled: boolean = true;
  public assignmentTypeFilterId: number = this.crudConfig.getFilterId();
  public assignmentStatusFilterId: number = this.crudConfig.getFilterId();

  constructor(
    datagridService: DatagridService,
    private crudConfig: CrudConfig,
    private router: UIRouter
  ) {
    super(datagridService);
  }

  public ngOnInit(): void {
    if(!this.router.stateService.params.assignment) {
      this.requestParams
        .addFilterParam({
          id: this.assignmentStatusFilterId,
          key: 'assignment.status',
          operator: 'eq',
          value: 'PROCESSED'
        })
        .addFilterParam({
          id: this.assignmentTypeFilterId,
          key: 'assignment.type',
          operator: 'ne',
          value: 'SURVEY'
        });
    }

    this.datagridListComponent.config.throughputSubgrid.enabled = true;
    this.datagridListComponent.config.exportation.enabled = true;
    this.datagridListComponent.config.bulkEdit.enabled = !!this.router.stateService.params.assignment; // Only for assignment views show bulk edit btn
    this.datagridListComponent.config.loadProfile = true;

    // If the assignment or maintenance state param is set, do search on init, otherwise skip init search for performance gain
    if(!this.router.stateService.params.assignment && !this.router.stateService.params.maintenance) {
      this.datagridListComponent.config.searchOnInit = false;
    }

    super.ngOnInit();
  }
}




// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/archive/archive-employee-overview.component.ts